export function sortQuestionByRefCode(
  currentQuestion: { refCode: string },
  candidateQuestion: { refCode: string },
) {
  const currentQRefCodeSegments = currentQuestion.refCode.replace('D', '').split('-').map(Number);
  const candidateQRefCodeSegments = candidateQuestion.refCode
    .replace('D', '')
    .split('-')
    .map(Number);

  for (let i = 0; i < currentQRefCodeSegments.length; i++) {
    if (currentQRefCodeSegments[i] !== candidateQRefCodeSegments[i]) {
      return currentQRefCodeSegments[i] - candidateQRefCodeSegments[i];
    }
  }

  return 0;
}
